import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

export const BillingIcon = createIcon({
  displayName: 'BillingIcon',
  viewBox: '22 22 468 468',
  path: (
    <>
      <path
        d='M32 64H448C452.418 64 456 67.5817 456 72V184C456 188.418 452.418 192 448 192H32C27.5817 192 24 188.418 24 184V72C24 67.5817 27.5817 64 32 64Z'
        fill='#3884FE'
      />
      <path
        d='M88 104H392C405.255 104 416 114.745 416 128C416 141.255 405.255 152 392 152H88C74.7452 152 64 141.255 64 128C64 114.745 74.7452 104 88 104Z'
        fill='white'
        stroke='#FCD673'
        strokeWidth='20'
      />
      <path
        d='M360 272H448C465.673 272 480 286.327 480 304V336H424V400C424 417.673 409.673 432 392 432C374.327 432 360 417.673 360 400V272Z'
        fill='white'
        stroke='#73B3AB'
        strokeWidth='16'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M120 112H360V400C360 417.673 374.327 432 392 432H152C134.327 432 120 417.673 120 400V112Z'
        fill='white'
      />
      <path
        d='M360 112V400C360 417.673 374.327 432 392 432H152C134.327 432 120 417.673 120 400V112'
        fill='none'
        stroke='#73B3AB'
        strokeWidth='16'
        strokeLinecap='butt'
        strokeLinejoin='round'
      />
      <path
        d='M424 336H480'
        fill='none'
        stroke='#73B3AB'
        strokeWidth='16'
        strokeLinecap='butt'
      />
      <path
        d='M392 432C409.673 432 424 417.673 424 400V304C424 286.327 434.745 272 448 272'
        fill='none'
        stroke='#73B3AB'
        strokeWidth='16'
        strokeLinecap='butt'
        strokeLinejoin='round'
      />
      <path
        d='M256 184C256 175.163 248.837 168 240 168C231.163 168 224 175.163 224 184C224 194.667 232 198.667 240 202.667C248 206.667 256 210.667 256 221.333C256 231.643 248.837 240 240 240C231.163 240 224 232.837 224 224M240 160V168M240 240V248'
        fill='none'
        stroke='#0E3663'
        strokeWidth='16'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
      <path d='M128 288H256' fill='none' stroke='#0E3663' strokeWidth='16' />
      <path d='M128 320H248' fill='none' stroke='#0E3663' strokeWidth='16' />
      <path d='M128 352H216' fill='none' stroke='#0E3663' strokeWidth='16' />
      <path d='M128 384H216' fill='none' stroke='#0E3663' strokeWidth='16' />
    </>
  ),
});
